import CardGallery from "./CardGallery";

const CardGalleryWithProps = ({ blok }) => {
  return <CardGallery title={blok.title} cards={blok.cards} />;
};

export default CardGalleryWithProps;
